import { createI18nInstance } from '/utilities/i18n';

const defaultFilter = {
	isFilter: true,
	filterProcessor: 'default', // filtre verisinin ne şekilde işlenip filtre modalına aktarılacağını belirler
	title: 'Filtre', // filtre başlığı
	valueKey: 'id', // filtre verisinin value alanının hangi field'dan geleceğini belirler
	labelKey: 'name', // filtre verisinin label (metin) alanının hangi field'dan geleceğini belirler
	valueFormat: 'string', // query string'den gelen value alanının formatı.
	affectedFields: [], // query'nin filtre içerisinde etkileşim kurduğu ek fieldlar (temizleme işlemleri için kullanılır)
};

export const getListingFilters = (language) => {
	const { t } = createI18nInstance(language);
	const translatedDefaultFilter = {
		...defaultFilter,
		title: t('Filtre'),
	};

	return {
		// Unlisted / Custom
		limit: {
			...translatedDefaultFilter,
			filterProcessor: false,
		},
		type: {
			...translatedDefaultFilter,
			filterProcessor: false,
		},
		term: {
			...translatedDefaultFilter,
			filterProcessor: false,
		},
		location: {
			...translatedDefaultFilter,
			filterProcessor: false,
		},
		venue: {
			...translatedDefaultFilter,
			filterProcessor: false,
		},
		page: {
			...translatedDefaultFilter,
			filterProcessor: false,
		},
		order: {
			...translatedDefaultFilter,
			filterProcessor: false,
		},
	};
};

const eventListingFilters = getListingFilters();

export default eventListingFilters;
